module.exports = ".containerSpinner {\n    position: relative;\n}\nspinner-component {\n    position: absolute;\n    top: -5px;\n    right: 12px;\n}\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/despachos/licenciamentos/licenciamento-form/licenciamento-form.component.css
 ** module id = 809
 ** module chunks = 0
 **/